import { useState } from "react";
import { truncateText } from "../../utils/Uility";
import { Chip } from "@material-tailwind/react";
import { useDispatch } from "react-redux";
import { addToCart } from "../../features/cart/cartSlice";
import { Dialog } from "@headlessui/react";
import DetailProduct from "./DetailProduct";
import { shoppingSvg } from "../../assets/images";

function ListProduct({ item }) {
  const [quantity, setQuantity] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handleDecrement = () => {
    setQuantity((prevQuantity) => Math.max(prevQuantity - 1, 1));
  };

  const handleIncrement = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const handleAddToCart = () => {
    dispatch(addToCart({ ...item, quantity }));
  };

  const toggleModal = () => {
    setIsOpen((prevOpen) => !prevOpen);
  };

  const imageSrc = item.image
    ? `${process.env.REACT_APP_BACK_URL}${item.image}`
    : shoppingSvg;

  return (
    <>
      <div className="text-center cursor-pointer w-full " onClick={toggleModal}>
        <img
          src={imageSrc}
          alt={item.name}
          className="h-36 w-full mx-auto object-cover"
        />
        <h1 className="text-gray-800 mt-2 text-lg">
          {truncateText(item.name, 18)}
        </h1>
        <p className="text-gray-600 text-sm">
          {truncateText(item.description, 22)}
        </p>
        <div className="text-gray-800 my-2">
          Prix : {item.price} {item.unit}
        </div>
        <div className="flex justify-center">
          <Chip
            color={item.stock_quantity > 0 ? "green" : "red"}
            value={item.stock_quantity > 0 ? "Disponible" : "Rupture"}
          />
        </div>
      </div>

      <div className="flex my-4 gap-2 items-center justify-center">
        <button
          className="btn btn-sm px-4 btn-outline "
          onClick={handleDecrement}
          disabled={quantity <= 1 || item.stock_quantity <= 0}
        >
          -
        </button>
        <span className="bg-neutral text-white rounded-md px-5">
          {item.stock_quantity <= 0 ? "X" : quantity}
        </span>
        <button
          disabled={item.stock_quantity <= 0}
          className="btn btn-sm px-4 btn-outline"
          onClick={handleIncrement}
        >
          +
        </button>
      </div>

      <button
        disabled={item.stock_quantity <= 0}
        className="py-2 px-4 bg-black text-white rounded hover:bg-green-500 transition duration-0 hover:duration-500 disabled:opacity-50 w-full flex items-center justify-center text-sm md:text-base"
        onClick={handleAddToCart}
      >
        Ajouter
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 ml-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
      </button>

      <Dialog open={isOpen} onClose={toggleModal} className="relative z-30">
        <DetailProduct item={item} stateModal={toggleModal} />
      </Dialog>
    </>
  );
}

export default ListProduct;
